;(function() {
    var

        _report_id = null,

        //our json data for the lines
        _data = null,

        _error_message = null,


        //the move popup
        _$popup = null,

        //set to true when a popup is open, can't open another
        _popup_open = false,

        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-report');

            if (_$wrapper.length > 0) {
                //get the report id
                _report_id = _$wrapper.find('#hdnReportID').val();

                setupMove();
            }
        },


        //
        // setup the move click on the main report page to open the popup
        //
        setupMove = function () {
            _$wrapper.on('click', '.lnk-move', function () {
                $a = $(this);
                // Get the next sibling element
                var spinner = $a.next('.lnk-line-move-spinner');
                //show spinner and hide the move button
                spinner.show();
                $a.hide();

                if (!_popup_open) {
                    _popup_open = true;
                    var lineID = $(this).closest('tr').attr('data-line-id');

                    //hide the spinner and show the move button
                    spinner.hide();
                    $a.show();

                    //get the data 
                    delta.ajax.get(`/report/move?reportID=${_report_id}&lineID=${lineID}`,
                        function (json) {
                            //save the data
                            _data = json;

                            //open the popup
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Move Lines',
                                content: buildHtml(),
                                css: 'dlgMoveLine',
                                cssClass: 'move-lines-popup modal-xl',
                                okButtonText: 'Save',
                                afterOpen: function ($popup) {
                                    //save the popup
                                    _$popup = $popup;
                                    _popup_open = false;

                                    //setup drag/drop
                                    setupDragDrop();
                                },
                                okCallback: function () {
                                    $('.move-lines-popup .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    const lineMoves = [];
                                    for (var i = 0; i < _data.lines.length; i++) {
                                        lineMoves.push(_data.lines[i].lineID);
                                    }

                                    delta.ajax.post(`/report/move?reportID=${_report_id}`, lineMoves, function () { window.location.reload(); });
                                    return false; // don't keep it open
                                },
                            });
                        }
                    );
                }

                return false;
            });
        },

        //
        //render the contents of the popup
        //
        renderBody = function () {
            _$popup.find('.modal-body').html(buildHtml());

            setupDragDrop();
        },

        //
        // build & return the popup body
        //
        buildHtml = function () {

            reFormatLineIndentLevels();
            var s = '<div class="mb10 italic small">Click and drag to move lines and sections. Move sections by dragging their headings.</div>';
            s += '<div class="move-err mt10 small italic red ' + (_error_message == null ? 'hidden' : '') + '">' + _error_message + '</div>';

            //start of sort list
            s += '<div class="sortable">';
            s += writeReportMoveLine(_data.lines, 0);
            s += '</div>';

            _error_message = null;

            return s;
        },

        //
        // setup the drag/drop for the lines
        //
        setupDragDrop = function () {
            _$popup.find('.modal-body .sortable').sortable({ 
                items: '.dragSection, .dragLine',
                placeholder: "ui-state-highlight",
                tolerance: 'pointer',
                revert: 400, // animation
                cursorAt: { top: 12, left: 50 }, //try to use it with and without this option
                axis: 'y', // Restrict sorting to the vertical (Y) axis to ensure vertical sorting behavior.
                start: function (e, ui) {
                    ui.helper[0].style.border = '1px solid black';
                    ui.helper[0].style.boxShadow = '5px 5px 10px rgba(0, 0, 0, 0.4)';
                    ui.helper[0].style.transformOrigin = 'top left';
                    ui.helper[0].style.transform = ui.item.height() > 100 ? 'scale(.5)' : 'scale(.8)';

                    const draggedLineID = ui.item.attr('data-line-id'),
                        draggedLine = _data.lines.find(x => x.lineID === draggedLineID);

                    if (draggedLine.lineType == 'Detail') {
                        $(".sortable").sortable('option', 'containment', 'parent');
                    }
                    else if (draggedLine.lineType == 'SectionHead') {
                        $(".sortable").sortable('option', 'containment', '.sortRoot');
                    }
                },
                sort: function (e, ui) {
                    const ph = ui.placeholder[0],
                        coord = ui.item[0].getBoundingClientRect(), // cannot use ui.offset because it's wrong if the viewport is scrolled
                        root = this.querySelector('.sortRoot');

                    function nearestElement(y, elements) {
                        let nearest = null, minDistance = Infinity;
                        elements.forEach(e => {
                            const r = e.getBoundingClientRect(),
                                distance = Math.abs(y - (r.top + (r.height / 2)));
                            if (distance < minDistance) {
                                minDistance = distance;
                                nearest = e;
                            }
                        });
                        return nearest;
                    }

                    const targets = Array.from(
                            root.querySelectorAll('.dragLabel, .dragLine, .dragFoot, .ui-sortable-placeholder')
                        ).filter(e => !e.closest('.ui-sortable-helper'));
                    const trg = nearestElement(coord.top, targets);

                    if (
                        trg.classList.contains('dragLabel') ||
                        trg.classList.contains('dragLine') ||
                        trg.classList.contains('sortRoot')
                    ) {
                        trg.after(ph); // after the nearest element
                    }
                    else if (trg.classList.contains('dragFoot')) {
                        if (trg.parentElement.classList.contains('sortRoot')) trg.before(ph); // insert before final dragFoot 
                        else trg.parentElement.after(ph); // after the section
                    }
                },
                stop: function (e, ui) {
                    const draggedLineID = ui.item.attr('data-line-id'),
                        draggedLine = _data.lines.find(x => x.lineID === draggedLineID),
                        allLineElems = $('.dragSection, .dragLine, .nonDragLine, .dragFoot', _$popup),
                        draggedItemNewIndex = allLineElems.index(ui.item),
                        firstItemIndex = 0,
                        lastItemIndex = allLineElems.length;

                    if (draggedItemNewIndex <= firstItemIndex || draggedItemNewIndex >= lastItemIndex) {
                        $(".sortable").sortable('cancel');
                    }
                    else {
                        move(draggedLineID, draggedItemNewIndex);

                        //re-render the popup body
                        renderBody();
                    }
                }
            });
        },

        //
        // move - reposition item(s) in the line list, reformat the indent
        //  lineIndex - the lineIndex property of the line moved (which line got moved)
        //  newIndex - the new position of the line in the list
        // 
        move = function (lineID, newOffset) {
            const moveLine = _data.lines.find(x => x.lineID === lineID),
                moveLineIndex = _data.lines.indexOf(moveLine);
            let initIndex = _data.lines[0].lineIndex,
                newLines = [..._data.lines];

            if (moveLine.lineType == 'SectionHead') {

                const sectionEnd = _data.lines.find(x => x.lineType == 'SectionTotal' && x.sectionIndex == moveLine.sectionIndex),
                    sectionEndIndex = _data.lines.indexOf(sectionEnd),
                    sectionLines = _data.lines.slice(moveLineIndex, sectionEndIndex + 1),
                    moveDistance = newOffset - moveLineIndex; // positive is down; negative is up

                if (sectionEndIndex + moveDistance <= 1 ||
                    sectionEndIndex + moveDistance >= _data.lines.length
                ) {
                    _error_message = "Sorry, cannot move the section to that location!";
                    return;
                }

                newLines.splice(moveLineIndex, sectionLines.length); // remove sectionLines
                newLines.splice(newOffset, 0, ...sectionLines); // relocate sectionLines

                for (let i = 0; i < newLines.length; i++) {
                    newLines[i].lineIndex = initIndex++;
                }

            }
            else { // Detail Lines

                newLines.splice(moveLineIndex, 1); // remove moveLine
                newLines.splice(newOffset, 0, moveLine); // relocate moveLine

                let sectionStack = [];
                for (let i = 0; i < newLines.length; i++) {
                    let l = newLines[i];
                    if (l.lineType == "SectionHead") sectionStack.push(l.sectionIndex);
                    else if (l.lineType == "SectionTotal" &&
                        (sectionStack.length == 0 || (sectionStack.length > 0 && l.sectionIndex != sectionStack.pop()))
                    ) {
                        _error_message = "Sorry, invalid section header/footer order.";
                        return;
                    }
                    l.lineIndex = initIndex++;
                }
            }

            _data.lines = newLines;

            // Reformat the indent levels
            reFormatLineIndentLevels();
            $(".sortable").sortable('refresh');
        },

        writeReportMoveLine = function (lines, index) {
            if (index >= lines.length) return '';
            const line = lines[index];
            let s = '';

            if (line.lineType == 'SectionHead') {
                s += '<div class="'; // begin section div class

                if (index == 0) s += `sortRoot`;
                if (line.indent > 0) s += ` indent-${line.indent}`;
                if (line.canMove) s += ' dragSection'; else s += ' nonDragLine';

                s += `" data-line-id="${line.lineID}" title="Move Section">`; // end section div class
                s += `<div class="${line.bold ? 'bold dragLabel' : 'dragLabel'}">${line.label}</div>`; // section label
                s += writeReportMoveLine(lines, index+1); // inner lines
            }
            else if (line.lineType == 'SectionTotal') {
                s += '<div class="dragFoot'; // begin section div class
                if (line.indent > 0) s += ` indent-${line.indent}`;
                if (line.bold) s += ' bold';
                s += `">${line.label}</div>`;
                s += '</div>'; // close section div
                s += writeReportMoveLine(lines, index + 1); // following lines
            }
            else {
                s += '<div class="';
                if (line.indent > 0) s += ` indent-${line.indent}`;
                if (line.canMove) s += ' dragLine';  else s += ' nonDragLine';
                if (line.bold) s += ' bold';
                s += `" data-line-id="${line.lineID}" title="Move Detail Line">${line.label}</div>`;
                s += writeReportMoveLine(lines, index+1); // following lines
            }

            return s;
        },

        reFormatLineIndentLevels = function () {
            // Reformat the indent levels
            var indentLevel = 0;

            for (var i = 0; i < _data.lines.length; i++) {
                if (_data.lines[i].lineType == "SectionHead")
                    _data.lines[i].indent = indentLevel++;
                else if (_data.lines[i].lineType == "SectionTotal")
                    _data.lines[i].indent = --indentLevel;
                else
                    _data.lines[i].indent = indentLevel;
            }
        };

    $(document).ready(init);
})();

